(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var OPEN_DELAY = 600;
  var CART_CHECK_DELAY = 200;
  var CLOSE_AFTER_ADD = 900;
  var NEXT_PICK_DELAY = 700;
  var CART_MUTATION_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var SEEN_QTY_KEY = 'fg-seen-main-qty';

  function readSeenQty() {
    try {
      var value = sessionStorage.getItem(SEEN_QTY_KEY);
      return value === null ? null : Number(value);
    } catch (e) {
      return null;
    }
  }

  function writeSeenQty(qty) {
    try {
      sessionStorage.setItem(SEEN_QTY_KEY, String(qty));
    } catch (e) {}
  }

  function cartChangedBeforeLoad() {
    if (!window.performance || typeof performance.getEntriesByType !== 'function') return false;
    return performance.getEntriesByType('resource').some(function (entry) {
      return CART_MUTATION_URL.test(entry.name);
    });
  }

  function init() {
    var modal = document.querySelector('[data-fg-modal]');
    var configEl = document.querySelector('[data-fg-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    if (!modal && !config.auto) return;

    function find(selector) {
      return modal ? modal.querySelector(selector) : null;
    }

    function findAll(selector) {
      return modal ? Array.prototype.slice.call(modal.querySelectorAll(selector)) : [];
    }

    var panel = find('[data-fg-panel]');
    var scrollArea = find('.fg-modal__scroll');
    var list = find('.fg-modal__list');
    var errorEl = find('[data-fg-error]');
    var statusEl = find('[data-fg-status]');
    var counterEl = find('[data-fg-counter]');
    var addButtons = findAll('[data-fg-add]');
    var navButtons = findAll('[data-fg-nav]');
    var reminder = document.querySelector('[data-fg-reminder]');
    var reminderText = reminder && reminder.querySelector('[data-fg-reminder-text]');
    var html = document.documentElement;

    var isOpen = false;
    var isBusy = false;
    var openPending = false;
    var addedScrollLock = false;
    var lastFocused = null;
    var closeTimer = null;
    var openTimer = null;
    var cartCheckTimer = null;
    var offsetFrame = null;
    var navFrame = null;
    var gokwikObserved = false;
    var latestCart = null;
    var initialMainQty = Number(config.initialMainQty) || 0;
    var initialGiftQty = Number(config.initialGiftQty) || 0;

    // A main product added or removed before this script ran (slow load, or a full page cart change) still counts.
    var seenQty = readSeenQty();
    var lastMainQty = seenQty !== null ? seenQty : initialMainQty;

    function prefersReducedMotion() {
      return (
        modal.classList.contains('fg-modal--no-motion') ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      );
    }

    function transitionMs() {
      return prefersReducedMotion() ? 0 : 260;
    }

    function isFreebieLine(item) {
      return !!(item.properties && item.properties._freebie);
    }

    function getMainQty(cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.reduce(function (sum, item) {
        if (item.product_id === config.mainProductId && !isFreebieLine(item)) {
          return sum + item.quantity;
        }
        return sum;
      }, 0);
    }

    function getGiftLines(cart) {
      return cart && cart.items ? cart.items.filter(isFreebieLine) : [];
    }

    function getGiftQty(cart) {
      return getGiftLines(cart).reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);
    }

    function getOpenSlots(cart) {
      return Math.max(getMainQty(cart) - getGiftQty(cart), 0);
    }

    function setError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function announce(message) {
      if (statusEl) statusEl.textContent = message;
    }

    function updateCounter() {
      if (!counterEl) return;
      if (!latestCart) {
        counterEl.hidden = true;
        return;
      }

      var slots = getOpenSlots(latestCart);
      var hasGifts = getGiftQty(latestCart) > 0;

      if (slots < 1 || (slots === 1 && !hasGifts)) {
        counterEl.hidden = true;
        return;
      }

      var noun = slots === 1 ? 'free gift' : 'free gifts';
      counterEl.textContent = 'Pick ' + slots + (hasGifts ? ' more ' : ' ') + noun;
      counterEl.hidden = false;
    }

    function setLastMainQty(qty) {
      lastMainQty = qty;
      writeSeenQty(qty);
    }

    function currentOpenSlots() {
      if (latestCart) return getOpenSlots(latestCart);
      return Math.max(initialMainQty - initialGiftQty, 0);
    }

    function updateReminder() {
      if (!reminder) return;
      var slots = currentOpenSlots();
      if (isOpen || openPending || slots < 1) {
        reminder.hidden = true;
        return;
      }
      if (reminderText) {
        reminderText.textContent = slots === 1 ? 'Pick your free gift' : 'Pick ' + slots + ' free gifts';
      }
      reminder.hidden = false;
      syncReminderOffset();
    }

    // GoKwik renders its mobile "View cart" bar inside its own shadow root.
    function getGokwikRoot() {
      var host = document.querySelector('shadow-dom-container');
      return host && host.shadowRoot;
    }

    function coveredFromBottom(el) {
      if (!el) return 0;
      var rect = el.getBoundingClientRect();
      if (!rect.height || rect.top >= window.innerHeight || rect.bottom < window.innerHeight - 2) return 0;
      if (window.getComputedStyle(el).visibility === 'hidden') return 0;
      return Math.max(window.innerHeight - rect.top, 0);
    }

    function syncReminderOffset() {
      if (!reminder || reminder.hidden) return;
      watchGokwikBar();

      // Prestige pins the sticky bar to the top on desktop and to the bottom on mobile.
      var offset = coveredFromBottom(document.querySelector('product-sticky-bar'));
      var gokwikRoot = getGokwikRoot();
      if (gokwikRoot) {
        offset = Math.max(offset, coveredFromBottom(gokwikRoot.querySelector('.sticky-cart')));
      }
      reminder.style.setProperty('--fg-reminder-offset', offset + 'px');
    }

    function queueReminderOffset() {
      if (offsetFrame) return;
      offsetFrame = window.requestAnimationFrame(function () {
        offsetFrame = null;
        syncReminderOffset();
      });
    }

    function watchGokwikBar() {
      if (gokwikObserved || !window.MutationObserver) return;
      var root = getGokwikRoot();
      if (!root) return;
      gokwikObserved = true;
      new MutationObserver(queueReminderOffset).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    // Prestige swaps the sticky bar out on variant changes, so its wrapper is watched instead of the bar.
    function watchStickyBar() {
      var stickyBar = document.querySelector('product-sticky-bar');
      if (!stickyBar || !stickyBar.parentElement || !window.MutationObserver) return;
      new MutationObserver(queueReminderOffset).observe(stickyBar.parentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
      stickyBar.parentElement.addEventListener('transitionend', queueReminderOffset);
    }

    function updateNav() {
      if (!list || !navButtons.length) return;
      var maxScroll = list.scrollWidth - list.clientWidth;
      navButtons.forEach(function (btn) {
        var atEdge =
          Number(btn.getAttribute('data-fg-nav')) < 0 ? list.scrollLeft <= 1 : list.scrollLeft >= maxScroll - 1;
        var disable = maxScroll <= 1 || atEdge;
        if (disable && document.activeElement === btn) {
          var other = navButtons.filter(function (b) {
            return b !== btn;
          })[0];
          if (other && maxScroll > 1) {
            other.disabled = false;
            other.focus({ preventScroll: true });
          }
        }
        btn.disabled = disable;
      });
    }

    function queueNavUpdate() {
      if (navFrame) return;
      navFrame = window.requestAnimationFrame(function () {
        navFrame = null;
        updateNav();
      });
    }

    // Pages by the number of whole cards in view, so the next card always starts flush on the left.
    function scrollGifts(direction) {
      var card = list && list.querySelector('.fg-card');
      if (!card) return;
      var style = window.getComputedStyle(list);
      var gap = parseFloat(style.columnGap) || 0;
      var step = card.offsetWidth + gap;
      var visible = list.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
      var perPage = Math.max(Math.floor((visible + gap + 1) / step), 1);
      list.scrollBy({ left: direction * step * perPage, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }

    function getFocusable() {
      return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function onKeydown(event) {
      if (!isOpen) return;

      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        if (!isBusy) close();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusable();
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function resetButtons() {
      addButtons.forEach(function (btn) {
        btn.classList.remove('is-loading', 'is-added');
        btn.removeAttribute('aria-busy');
      });
      modal.classList.remove('is-busy');
      isBusy = false;
    }

    function open() {
      if (isOpen) return;
      clearTimeout(closeTimer);

      isOpen = true;
      openPending = false;
      lastFocused = document.activeElement;
      setError('');
      announce('');
      resetButtons();
      updateCounter();
      updateReminder();

      modal.hidden = false;
      if (scrollArea) scrollArea.scrollTop = 0;
      if (list) list.scrollLeft = 0;
      updateNav();
      // Force a reflow so the opening transition runs from the closed state.
      void modal.offsetHeight;
      modal.setAttribute('data-state', 'open');

      if (!html.classList.contains('lock')) {
        html.classList.add('lock');
        addedScrollLock = true;
      }

      document.addEventListener('keydown', onKeydown);

      var target = addButtons[0] || getFocusable()[0] || panel;
      setTimeout(function () {
        target.focus({ preventScroll: true });
      }, transitionMs());
    }

    function close() {
      clearTimeout(openTimer);
      openPending = false;
      if (!isOpen) {
        updateReminder();
        return;
      }

      isOpen = false;
      modal.setAttribute('data-state', 'closed');
      document.removeEventListener('keydown', onKeydown);
      updateReminder();

      if (addedScrollLock) {
        html.classList.remove('lock');
        addedScrollLock = false;
      }

      closeTimer = setTimeout(function () {
        modal.hidden = true;
        resetButtons();
      }, transitionMs());

      if (lastFocused && typeof lastFocused.focus === 'function' && document.contains(lastFocused)) {
        lastFocused.focus({ preventScroll: true });
      }
    }

    function scheduleOpen() {
      clearTimeout(openTimer);
      openPending = true;
      updateReminder();
      openTimer = setTimeout(function () {
        openPending = false;
        if (!latestCart || getOpenSlots(latestCart) > 0) {
          open();
        } else {
          updateReminder();
        }
      }, OPEN_DELAY);
    }

    function fetchCart() {
      return fetch(config.cartUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        return res.json();
      });
    }

    function postJson(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error((data && (data.description || data.message)) || 'Something went wrong. Please try again.');
          }
          return data;
        });
      });
    }

    // The GoKwik drawer only re-renders on its own cart calls, so it has to be told about ours.
    function broadcastCart(cart) {
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      if (typeof window.refreshSideCart === 'function') {
        window.refreshSideCart(false, false, true).catch(function () {});
      }
    }

    // Shopify lists the most recently added lines first, so trimming starts with the newest gift.
    function trimExtraGifts(cart) {
      var excess = getGiftQty(cart) - getMainQty(cart);
      if (excess <= 0) return Promise.resolve(cart);

      var updates = {};
      getGiftLines(cart).forEach(function (line) {
        if (excess <= 0) return;
        var remove = Math.min(line.quantity, excess);
        updates[line.key] = line.quantity - remove;
        excess -= remove;
      });

      return postJson(config.cartUpdateUrl, { updates: updates }).then(function (updatedCart) {
        broadcastCart(updatedCart);
        return updatedCart;
      });
    }

    function getAutoVariantQty(cart) {
      return cart.items.reduce(function (sum, item) {
        return item.variant_id === config.autoVariantId ? sum + item.quantity : sum;
      }, 0);
    }

    // The admin discount decides which units are free, so the theme only keeps one gift unit per main product in the cart.
    // Gifts are only added when the main product goes up, so a gift the customer deletes stays deleted.
    function syncAutoGifts(cart) {
      var mainQty = getMainQty(cart);
      var previousQty = lastMainQty;
      latestCart = cart;
      setLastMainQty(mainQty);

      if (mainQty > previousQty) {
        var missing = Math.min(mainQty - previousQty, mainQty - getAutoVariantQty(cart));
        if (missing > 0) addAutoGifts(missing);
      } else if (mainQty < previousQty) {
        var extra = Math.min(previousQty - mainQty, getAutoVariantQty(cart) - mainQty);
        if (extra > 0) removeAutoGifts(cart, extra);
      }
    }

    function removeAutoGifts(cart, quantity) {
      var updates = {};
      getGiftLines(cart).forEach(function (line) {
        if (quantity <= 0) return;
        var remove = Math.min(line.quantity, quantity);
        updates[line.key] = line.quantity - remove;
        quantity -= remove;
      });
      if (!Object.keys(updates).length) return;
      isBusy = true;
      postJson(config.cartUpdateUrl, { updates: updates })
        .then(function (updatedCart) {
          latestCart = updatedCart;
          broadcastCart(updatedCart);
        })
        .catch(function () {})
        .then(function () {
          isBusy = false;
        });
    }

    function evaluateCart(cart) {
      if (!cart || !cart.items || isBusy) return;

      if (config.auto) {
        syncAutoGifts(cart);
        return;
      }

      if (getGiftQty(cart) > getMainQty(cart)) {
        isBusy = true;
        trimExtraGifts(cart)
          .catch(function () {
            return cart;
          })
          .then(function (updatedCart) {
            isBusy = false;
            evaluateCart(updatedCart);
          });
        return;
      }

      latestCart = cart;
      var mainQty = getMainQty(cart);
      var mainIncreased = mainQty > lastMainQty;
      setLastMainQty(mainQty);
      var slots = getOpenSlots(cart);

      if (isOpen) {
        if (slots < 1) {
          close();
        } else {
          updateCounter();
        }
        return;
      }

      if (mainIncreased && slots > 0) {
        scheduleOpen();
      } else {
        updateReminder();
      }
    }

    function scheduleCartCheck() {
      clearTimeout(cartCheckTimer);
      cartCheckTimer = setTimeout(function () {
        if (isBusy) return;
        fetchCart()
          .then(evaluateCart)
          .catch(function () {});
      }, CART_CHECK_DELAY);
    }

    // The GoKwik cart dispatches cartcount:update with only { item_count }, sometimes twice per add.
    function onCartUpdate(event) {
      if (isBusy) return;
      var detail = event && event.detail;

      if (detail && detail.items) {
        evaluateCart(detail);
        return;
      }

      scheduleCartCheck();
    }

    // GoKwik's drawer +/- buttons change the cart without a theme event, so watch the requests themselves.
    function watchCartRequests() {
      if (window.fetch) {
        var originalFetch = window.fetch;
        window.fetch = function (input, init) {
          var url = typeof input === 'string' ? input : input && input.url;
          var method = (init && init.method) || (input && input.method) || 'GET';
          var promise = originalFetch.apply(this, arguments);
          if (url && method.toUpperCase() === 'POST' && CART_MUTATION_URL.test(url)) {
            promise.then(scheduleCartCheck, function () {});
          }
          return promise;
        };
      }

      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__fgCartMutation = String(method).toUpperCase() === 'POST' && CART_MUTATION_URL.test(String(url));
        return originalOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        if (this.__fgCartMutation) {
          this.addEventListener('load', scheduleCartCheck);
        }
        return originalSend.apply(this, arguments);
      };
    }

    function addAutoGifts(quantity) {
      if (isBusy || !config.autoVariantId) return;
      isBusy = true;

      postJson(config.cartAddUrl, {
        items: [{ id: config.autoVariantId, quantity: quantity, properties: { _freebie: 'true' } }]
      })
        .then(fetchCart)
        .then(function (cart) {
          latestCart = cart;
          setLastMainQty(getMainQty(cart));
          broadcastCart(cart);
          document.dispatchEvent(
            new CustomEvent('free-gift:added', {
              detail: { cart: cart, variantId: config.autoVariantId, openSlots: getOpenSlots(cart) }
            })
          );
        })
        .catch(function () {})
        .then(function () {
          isBusy = false;
        });
    }

    function addGift(button) {
      if (isBusy) return;

      var variantId = Number(button.getAttribute('data-variant-id'));
      if (!variantId) return;

      if (latestCart && getOpenSlots(latestCart) < 1) {
        close();
        return;
      }

      isBusy = true;
      setError('');
      modal.classList.add('is-busy');
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      postJson(config.cartAddUrl, {
        items: [{ id: variantId, quantity: 1, properties: { _freebie: 'true' } }]
      })
        .then(fetchCart)
        .then(function (cart) {
          latestCart = cart;
          setLastMainQty(getMainQty(cart));
          var slots = getOpenSlots(cart);

          button.classList.remove('is-loading');
          button.classList.add('is-added');

          var title = button.getAttribute('data-gift-title') || 'Gift';
          announce(
            title + ' added to your cart.' + (slots > 0 ? ' ' + slots + ' more free ' + (slots === 1 ? 'gift' : 'gifts') + ' to pick.' : '')
          );

          broadcastCart(cart);
          document.dispatchEvent(
            new CustomEvent('free-gift:added', { detail: { cart: cart, variantId: variantId, openSlots: slots } })
          );

          if (slots > 0) {
            setTimeout(function () {
              resetButtons();
              updateCounter();
            }, NEXT_PICK_DELAY);
          } else {
            setTimeout(close, CLOSE_AFTER_ADD);
          }
        })
        .catch(function (error) {
          resetButtons();
          setError(error && error.message ? error.message : 'Could not add your gift. Please try again.');
        });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        var addBtn = event.target.closest('[data-fg-add]');
        if (addBtn) {
          addGift(addBtn);
          return;
        }
        var navBtn = event.target.closest('[data-fg-nav]');
        if (navBtn) {
          scrollGifts(Number(navBtn.getAttribute('data-fg-nav')));
          return;
        }
        if (event.target.closest('[data-fg-close]') && !isBusy) {
          close();
        }
      });
    }

    if (reminder) {
      reminder.addEventListener('click', open);
      syncReminderOffset();
      watchStickyBar();
      window.addEventListener('resize', queueReminderOffset);
      window.addEventListener('load', queueReminderOffset);
    }

    if (list) {
      list.addEventListener('scroll', queueNavUpdate, { passive: true });
      window.addEventListener('resize', queueNavUpdate);
    }

    window.addEventListener('cartcount:update', onCartUpdate);
    watchCartRequests();

    if (modal) {
      window.FreeGiftModal = { open: open, close: close };
    }

    if (config.preview && modal) {
      scheduleOpen();
    } else if (lastMainQty !== initialMainQty || cartChangedBeforeLoad()) {
      scheduleCartCheck();
    } else {
      writeSeenQty(initialMainQty);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
